import clsx from 'clsx';

// src/cn.ts
function cn(...inputs) {
  return clsx(inputs);
}

export { cn };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map